<div
  class="h-100 d-flex flex-column align-items-center align-items-sm-start"
  [ngClass]="areSectionsVisible ? 'justify-content-between' : 'justify-content-start'"
>
  <div class="d-flex flex-column w-100">
    <div class="d-flex d-sm-none justify-content-end pt-3 pe-3">
      <i
        class="pointer font-size-lg fa-solid fa-circle-xmark"
        (click)="closeSidebar()"
      ></i>
    </div>
    <ng-container *ngIf="areSectionsVisible">
      <base-vertical-nav
        [tabs]="sections"
        [isCentralisedForSmallScreen]="true"
        (currentChange)="closeSidebar()"
      ></base-vertical-nav>
      <a
        *ngIf="portalSettings.links.urls.help"
        class="d-lg-none nav-link d-flex align-items-center justify-content-sm-start justify-content-center avoid-highlight-active text-uppercase px-4 py-3 fw-bold hover-text-primary"
        target="_blank"
        [href]="portalSettings.links.urls.help"
      >
        <i class="d-flex align-items-center justify-content-center headline-18 fa-solid fa-question-circle me-3"></i>
        <span>{{ 'help' | translate }}</span>
      </a>
    </ng-container>
  </div>
  <base-legal-document-links [increasedFontSize]="!areSectionsVisible"></base-legal-document-links>
</div>
